import ActionCard from "@/components/ActionCard";
import useCapabilities, { useDenyAuthorization } from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import usePageTitle from "@/hooks/usePageTitle";
import { Path, useNavigate } from "@/router";
import { useEffect } from "react";
import TabLayout from "../_TabLayout";
import { canShowGrpFinanceChrome } from "./_utils";

export default function FinancePage() {
  usePageTitle("/billing/finance", "Billing | Finance");
  const navigate = useNavigate();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded, capabilities } = useCapabilities();
  const denyAuthorization = useDenyAuthorization();
  const canViewGrp = canShowGrpFinanceChrome(flags, capabilities);

  useEffect(() => {
    if (!loaded || !flagsLoaded) return;
    if (!canViewGrp) denyAuthorization("/billing/orders" as Path);
  }, [loaded, flagsLoaded, canViewGrp, denyAuthorization]);

  return (
    <TabLayout>
      {canViewGrp && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[90rem] pt-12">
          <div>
            <ActionCard
              actionFn={() => navigate("/billing/finance/grp")}
              iconName="volunteer_activism"
              title="Golf Retirement Plus"
              text="Manage member and sponsor contributions for the Golf Retirement Plus benefit program."
            />
          </div>
        </div>
      )}
    </TabLayout>
  );
}
